// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import KindPropType from 'app/common/KindPropType';
import 'app/common/components/BooleanInput.scss';

const bem = bemify('boolean-input');

const typeToIcon = {
  checkbox: 'check-alt',
  radio: 'disc',
};

const WrapperNode = ({ children, hasExternalLabel, ...props }) =>
  React.createElement(hasExternalLabel ? 'span' : 'label', props, children);

const BooleanInput = createReactClass({
  displayName: 'BooleanInput',

  propTypes: {
    checked: PropTypes.bool.isRequired,
    hasExternalLabel: PropTypes.bool.isRequired,
    indeterminate: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    className: PropTypes.string,
    kind: KindPropType,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func.isRequired,
    'aria-label': PropTypes.string,
  },

  getDefaultProps() {
    return {
      hasExternalLabel: false,
      onChange: () => {},
      onChangeValue: () => {},
    };
  },

  onChange(e) {
    // Use `checked` from the DOM node to ensure accuracy.
    // Using `this.props.checked` can be trickier because
    // we need to negate it and there may be a race condition
    // between the event and when the DOM is updated.
    const { checked } = e.target;
    // But use `name` and `value` from `this.props` so they
    // aren't coerced to strings, especially `value`.
    const { name, value } = this.props;
    this.props.onChangeValue(checked, value, name);
    this.props.onChange(e);
  },

  render() {
    const { props } = this;
    const className = bem(
      toModifiers({
        checked: props.checked || props.indeterminate,
        disabled: props.disabled === true,
      }),
      toModifiers(props.kind, props.type),
      props.className
    );
    const iconProps = { className: bem('__icon') };
    const icon = props.indeterminate ? (
      <Icon {...iconProps} type="indeterminate" />
    ) : props.checked ? (
      <Icon {...iconProps} type={typeToIcon[props.type]} />
    ) : null;
    const inputProps = _.omit(props, [
      'hasExternalLabel',
      'indeterminate',
      'onChangeValue',
    ]);
    return (
      <WrapperNode
        aria-label={props['aria-label'] || props.name}
        className={className}
        hasExternalLabel={props.hasExternalLabel}
        role={props.type === 'radio' ? 'radio' : 'checkbox'}
      >
        <input
          tabIndex="0"
          {...inputProps}
          className={bem('__input')}
          disabled={props.disabled}
          name={props.name}
          onChange={this.onChange}
          type={props.type}
          value={props.value}
        />
        {icon}
      </WrapperNode>
    );
  },
});

export default BooleanInput;
